import { createContext, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import API from "./API/newIndex";
import ErrorPage from "./Component/Main/ErrorPage";
import ListMetaFieldGroup from "./Component/MetaFieldGroup/ListMetaFieldGroup";
import { GetClient } from "./controllers/GetClient";

export const ChangePathContext = createContext();
export const PlanPermission = createContext();
export const DataLoad = createContext();
export const SelectSection = createContext();
export const Extention = createContext();
export const StoreDeletePending = createContext();

const App = () => {
  const [installedExtensions, setInstalledExtensions] = useState([]);
  const [planActive, setPlanActive] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);

  let business_name = localStorage.getItem("business_name");
  const navigate = useNavigate();
  const searchPath = useLocation();

  const installExtentionName =
    installedExtensions?.length > 0 ? installedExtensions?.map((x) => x?.super_extension_id) : [];

  const [saveChanges, setSaveChanges] = useState({
    isUnsaveChanges: false,
    showChangesPopup: false,
    backLink: "",
    title: "",
  });
  const [planPermission, setPlanPermission] = useState({
    isPlanPermissions: true,
    forModule: null,
  });
  const [dataLoading, setDataLoading] = useState(false);
  const GetInstalledExtensions = async () => {
    try {
      const ApiCall = await API({
        url: `/admin/extension/GetInstalledExtensions`,
        method: "get",
      });
      if (ApiCall.data) {
        const result = ApiCall?.data;
        setInstalledExtensions(result?.data);
        return result?.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetUserPermissions = async () => {
    try {
      await API({ url: "/admin/role/getLoginUserRole", method: "get" });
    } catch (error) {
      console.log(error);
    }
  };

  const GetAnnouncemnet = async () => {
    try {
      await API({
        url: `/admin/announcement/UserGetAnnouncements?type=1&limit=3&page=1`,
        method: "get",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const CheckPlanStatus = async () => {
    if (business_name?.length > 0) {
      try {
        await API({ url: `/admin/plan/planStatusCheck`, method: "get" });
        setPlanActive(true);
        await GetInstalledExtensions();
        await GetUserPermissions();
        await GetAnnouncemnet();
      } catch (error) {
        if (error?.response?.status === 498) {
          setPlanActive(false);
        } else {
          console.log(error);
        }
      }
    } else {
      setPlanActive(false);
    }
  };

  useEffect(() => {
    const savedDarkMode = localStorage.getItem("dark-mode");
    if (savedDarkMode === "true" || savedDarkMode === true) {
      document.documentElement.classList.add("dark-mode");
    } else {
      document.documentElement.classList.remove("dark-mode");
    }
    if (window.self === window.top) {
      setAccessDenied(true);
      return;
    }
    if (!document.referrer || !document.referrer.startsWith(process.env.REACT_APP_ADMIN_URL)) {
      setAccessDenied(true);
      return true;
    }
    window.addEventListener("message", (event) => {
      if (event.origin === process.env.REACT_APP_ADMIN_URL) {
        const data = event.data;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            localStorage.setItem(key, data[key]);
          }
        }
        if (data?.type === "DARK_MODE_CHANGE" || data?.type === "INIT_IFRAME") {
          const isDarkModeVal =
            data?.type === "DARK_MODE_CHANGE"
              ? data["dark-mode"]
              : data["dark-mode"] === "true" || data["dark-mode"] === true;
          localStorage.setItem("dark-mode", isDarkModeVal);
          if (isDarkModeVal) {
            document.documentElement.classList.add("dark-mode");
          } else {
            document.documentElement.classList.remove("dark-mode");
          }
        }
      } else {
        console.warn("Message origin not trusted please check:", event.origin);
      }
      if (event.data?.type === "NAVIGATE_IFRAME_INTERNAL" && typeof event.data.path === "string") {
        navigate(event.data.path);
      }
    });
    GetInstalledExtensions();
    CheckPlanStatus();
    GetClient();
    if (searchPath?.pathname === "/") {
      navigate("/custom-field");
    }
  }, []);

  return (
    <>
      <ChangePathContext.Provider value={{ saveChanges, setSaveChanges }}>
        <PlanPermission.Provider value={{ planPermission, setPlanPermission }}>
          <DataLoad.Provider value={{ dataLoading, setDataLoading }}>
            <Routes>
              {installExtentionName?.length > 0 &&
                installExtentionName?.includes("6683f05c529fd09fc74be79c") && (
                  <Route path="/custom-field" element={planActive && <ListMetaFieldGroup />} />
                )}
              <Route path="/*" element={planActive || (accessDenied && <ErrorPage />)} />
            </Routes>
          </DataLoad.Provider>
        </PlanPermission.Provider>
      </ChangePathContext.Provider>
    </>
  );
};

export default App;
